import { render, staticRenderFns } from "./ReceiptType.vue?vue&type=template&id=438cd02e&scoped=true&"
import script from "./ReceiptType.vue?vue&type=script&lang=js&"
export * from "./ReceiptType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438cd02e",
  null
  
)

export default component.exports